import { defineStore } from "pinia";

interface State {
  addBlockDialog: {
    opened: boolean;
    addDirection: "top" | "bottom" | null;
    options: any;
  };

  addStructureDialog: {
    opened: boolean;
    addDirection: "top" | "bottom" | null;
  };

  addAiTextDialog: {
    opened: boolean;
    addDirection: "top" | "bottom" | null;
  };
}

export const useDialogsStore = defineStore("dialogs", {
  state: (): State => ({
    addBlockDialog: {
      opened: false,
      addDirection: "top",
      options: null,
    },
    addStructureDialog: {
      opened: false,
      addDirection: "top",
    },
    addAiTextDialog: {
      opened: false,
      addDirection: "top",
    },
  }),

  actions: {
    openBlockDialog({
      direction,
      options,
    }: {
      direction: "top" | "bottom" | null;
      options?: any;
    }) {
      this.addBlockDialog = {
        opened: true,
        addDirection: direction,
        options: options,
      };
    },

    closeBlockDialog() {
      this.addBlockDialog.opened = false;
      this.addBlockDialog.options = null;
    },

    openStructureDialog(direction: "top" | "bottom") {
      this.addStructureDialog = {
        opened: true,
        addDirection: direction,
      };
    },

    closeStructureDialog() {
      this.addStructureDialog.opened = false;
    },

    closeAiTextDialog() {
      this.addAiTextDialog.opened = false;
    },
  },
});
